import React from 'react'
import "./footer.css"

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <h1 className="footer__title">
                Unique Olga
            </h1>
            <ul className='footer__list'>
                <li>
                    <a href="#about" className="footer__link">About</a>
                </li>

                <li>
                    <a href="#portfolio" className="footer__link">Projects</a>
                </li>

                <li>
                    <a href="#testimonial" className="footer__link">Testimonials</a>
                </li>
            </ul>

            <div className="footer__social">
            <a href="https://wa.me/2348083783705?text=Hi,%20I%20want%20to%20make%20inquiries%20about" className="footer__social-link">
        <i class="uil uil-whatsapp"></i>
        </a>

        <a href="https://www.linkedin.com/in/olgacodes/" target="blank" rel="nooppener" className="footer__social-link">
        <i class="uil uil-linkedin-alt"></i>
        </a>

        <a href="mailto:olgacodes@outlook.com?subject=Hello,%20Unique%20Olga&body=Hello%20there!" target="blank" rel="nooppener" className="footer__social-link">
        <i class="uil uil-fast-mail"></i>
        </a>

        <a href="https://github.com/uniqueolgacodes" target="blank" rel="nooppener" className="footer__social-link">
        <i class="uil uil-github-alt"></i>
        </a>
            </div>


            <span className="footer__copy">
                &#169; OlgaCodes; All Rights Reserved
            </span>
        </div>
    </footer>
  )
}

export default Footer